module.exports = __webpack_public_path__ + "img/04.f4c3561e.jpg";